import * as React from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { AuthenticationResult, EventMessage, EventType, IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "./utils/NavigationClient";

import Home from "./Home";
import DarkModeSwitch, { useDarkMode } from "./components/DarkModeSwitch";

import Questions from "./Questions";
import { Box, Grommet, Stack } from "grommet";
import Theme from "./utils/Theme";
import { SkeletonTheme } from "react-loading-skeleton";
import { normalizeColor } from "grommet/utils";
import Splash from "./Splash";
import KnowledgeCheck from "./KnowledgeCheck";
import { msalInstance } from ".";
import SkeletonWrapper from "./components/SkeltonWrapper";
import ErrorBoundary from "./components/ErrorBoundary";
import AsteroidsGame from "./components/AsterioidsGame";

type AppProps = {
    pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);

    const [isDarkMode, toggleDarkMode] = useDarkMode();

    const [grommetProps, setGrommetProps] = React.useState({});

    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        // const locale = new Intl.Locale(navigator.language);
        // //@ts-ignore
        // if (locale.textInfo.direction == "rtl") {
        //     setGrommetProps({ dir: "rtl" });
        // } else {
        //     setGrommetProps({});
        // }

        pca.addEventCallback((event: EventMessage) => {
            if (event.eventType === EventType.HANDLE_REDIRECT_END) {
                setIsLoading(false);
            }
        });
    }, []);

    return (
        <MsalProvider instance={pca}>
            <Grommet {...grommetProps} full theme={Theme} themeMode={isDarkMode ? "dark" : "light"}>
                <SkeletonTheme baseColor={normalizeColor("background-back", Theme, isDarkMode)} highlightColor={normalizeColor("background-front", Theme, isDarkMode)}>
                    <SkeletonWrapper loading={isLoading}>
                        <Box background={{ color: "background" }}>
                            <DarkModeSwitch></DarkModeSwitch>

                            <Stack guidingChild={1}>
                                <Box align="center" style={{ backgroundSize: "cover" }} height={{ min: "100vh" }}>
                                    <Box width={{ max: "1100px" }} pad={{ left: "medium", right: "medium" }} style={{ position: "relative" }}>
                                        <ErrorBoundary>
                                            <AuthenticatedTemplate>
                                                <Routes>
                                                    <Route path="/knowledgeCheck/:id" element={<Questions></Questions>}></Route>
                                                    <Route path="/home" element={<Home></Home>}></Route>
                                                    <Route path="/*" element={<Home></Home>}></Route>
                                                    <Route path="/game" element={<AsteroidsGame></AsteroidsGame>}></Route>
                                                </Routes>
                                            </AuthenticatedTemplate>

                                            <UnauthenticatedTemplate>
                                                <Routes>
                                                    <Route path="/*" element={<Splash></Splash>}></Route>
                                                    <Route path="/game" element={<AsteroidsGame></AsteroidsGame>}></Route>
                                                </Routes>
                                            </UnauthenticatedTemplate>
                                        </ErrorBoundary>
                                    </Box>
                                </Box>
                            </Stack>
                        </Box>
                    </SkeletonWrapper>
                </SkeletonTheme>
            </Grommet>
        </MsalProvider>
    );
}

export default App;
